import Common from './Common';
import cache from '../utils/PromiseCache';

export default class Ambassador {
    static get(userId, { noCache = false, ttlMs = 20000 } = {}) {
        if (!userId) return Promise.resolve(false);

        const key = `Ambassador.get:${userId}`;
        const fetcher = () =>
            Common.request(Common.params({ url: `/v1/users/${userId}/achievements`, method: 'get' }));

        const transform = (response) => {
            if (!Array.isArray(response)) return response;
            const item = response.find((ach) => ach?.name === 'ambassador');
            return Boolean(item && (item.is_ambassador ?? item.value ?? true));
        };

        return cache.getTransformed(key, { ttlMs, noCache }, fetcher, transform);
    }
}
